import * as Scrivito from "scrivito";

import {
  defaultFormInputEditingAttributes,
  defaultFormInputEditingProperties,
  defaultFormInputInitialContent,
} from "../../_defaultFormEditingConfig";

Scrivito.provideEditingConfig("TextAreaWidget", {
  title: "Text area",
  attributes: {
    ...defaultFormInputEditingAttributes,
  },
  properties: [...defaultFormInputEditingProperties, "placeholder"],
  initialContent: {
    ...defaultFormInputInitialContent,
  },
  validations: [
    [
      "csvColumnName",
      (csvColumnName) => {
        if (!csvColumnName) {
          return "CSV column name is required";
        }
        return null;
      },
    ],
  ],
});
